<script setup lang="ts">
export type ModusDialogProps = {
  open: boolean
  onClose?: () => void
  hideCloseButton?: boolean
  overlayImageUrl?: string
  maxWidth?: string
}

const props = defineProps<ModusDialogProps>()

const handleClose = () => {
  if (props.onClose) {
    props.onClose()
  }
}
</script>

<template>
  <ModusDialogRoot :open="open">
    <ModusDialogPortal>
      <ModusDialogOverlay :image-url="overlayImageUrl" />
      <ModusDialogContent
        :class="{ 'hide-close-button': hideCloseButton }"
        :style="{ maxWidth: maxWidth }"
        @escape-key-down="handleClose"
        @interact-outside="handleClose"
      >
        <ModusDialogClose
          v-if="!hideCloseButton"
          class="close-button"
          @click="handleClose"
        />
        <div class="content-wrapper">
          <ModusDialogTitle as-child>
            <slot name="title" />
          </ModusDialogTitle>

          <ModusDialogDescription>
            <slot name="content" />
          </ModusDialogDescription>
        </div>
        <slot name="actions" />
      </ModusDialogContent>
    </ModusDialogPortal>
  </ModusDialogRoot>
</template>

<style scoped>
  .close-button {
    align-self: flex-end;
  }

  .hide-close-button {
    padding-top: 40px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
</style>
